import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import './Store.pcss';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { reInitializeSwiper } from '../../utils/re-initialize-swiper';
import { createSwiperControls } from '../../utils/create-swiper-controlls';
export const Store = () => {
    useEffect(() => {
        const listener = ({ detail }) => {
            const { element } = detail;
            element.classList.add('custom-store');
            removeEmptyStoreTabs();
            new MutationObserver((_, obs) => {
                observerFn(element);
            }).observe(element, {
                childList: true,
                subtree: true,
            });
        };
        window.addEventListener('custom:store:rendered', listener);
        return () => {
            window.removeEventListener('custom:store:rendered', listener);
        };
    }, []);
    return _jsx(_Fragment, {});
};
function observerFn(element) {
    const swiperWrapper = element.querySelector('.ui-site-swiper');
    createSwiperControls(swiperWrapper);
    const SwiperEl = element.querySelector('.swiper');
    if (!SwiperEl || !('swiper' in SwiperEl))
        return;
    const slideCount = SwiperEl.querySelectorAll('.swiper-slide').length;
    const hasMultipleSlides = slideCount > 1;
    const newParams = {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        modules: [Navigation, Pagination, Autoplay],
        autoplay: hasMultipleSlides ? { delay: 3000 } : false,
        pagination: {
            enabled: hasMultipleSlides,
            el: SwiperEl.closest('.ui-site-swiper')?.querySelector('.custom-swiper-controls .custom-swiper-pagination'),
            bulletActiveClass: 'custom-swiper-pagination__bullet--active',
            bulletClass: 'custom-swiper-pagination__bullet',
            clickable: true,
        },
        navigation: {
            enabled: hasMultipleSlides,
            prevEl: SwiperEl.closest('.ui-site-swiper')?.querySelector('.custom-swiper-controls .custom-swiper-controls__prev-button'),
            nextEl: SwiperEl.closest('.ui-site-swiper')?.querySelector('.custom-swiper-controls .custom-swiper-controls__next-button'),
        },
    };
    reInitializeSwiper(SwiperEl, newParams);
    if (!hasMultipleSlides) {
        swiperWrapper?.querySelector('.custom-swiper-controls')?.classList.add('is-hidden');
    }
}
function removeEmptyStoreTabs() {
    const HeaderLinks = document.querySelectorAll('.header-line__left a[href^="#"]');
    HeaderLinks.forEach((Link) => {
        const id = new URL(Link?.href).hash;
        if (!id)
            return;
        const block = document.querySelector(id);
        if (block) {
            Link.removeAttribute('style');
            return;
        }
        Link.style.display = 'none';
    });
}
